import React, { useState } from 'react';
import { Archive, X } from 'lucide-react';
import { toast } from 'sonner';
import { useData } from '../context/DataContext';
import { useT } from '../context/LanguageContext';

export const ARCHIEF_REDENEN = ['Verkocht', 'Gesloopt', 'Andere garage', 'Overig'];

export default function ArchiveerAutoDialog({ auto, onClose }) {
  const { t } = useT();
  const { archiveerKlantAuto } = useData();
  const [reden, setReden] = useState('');
  const [toelichting, setToelichting] = useState('');
  const [busy, setBusy] = useState(false);

  const save = async () => {
    if (!reden) { toast.error(t('Kies een reden')); return; }
    setBusy(true);
    try {
      await archiveerKlantAuto(auto.kenteken, { reden, toelichting });
      toast.success(t('Voertuig gearchiveerd'), { description: `${auto.kenteken} · ${t(reden)}` });
      onClose();
    } catch (e) {
      toast.error(t('Archiveren mislukt'), { description: e.response?.data?.detail || e.message });
    } finally { setBusy(false); }
  };

  return (
    <div className="cs-modal-overlay" style={{ zIndex: 300 }} onClick={onClose}>
      <div className="cs-modal" style={{ width: 440 }} onClick={e => e.stopPropagation()} data-testid="archiveer-auto-modal">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
          <h3 style={{ margin: 0 }}><Archive size={16} style={{ verticalAlign: -2, marginRight: 6 }} />{t('Voertuig archiveren')} · {auto.kenteken}</h3>
          <button className="cs-btn ghost" onClick={onClose} data-testid="archiveer-auto-close"><X size={14} /></button>
        </div>
        <p style={{ fontSize: 12.5, color: 'var(--cs-text-muted)', margin: '0 0 12px' }}>
          {t('De historie (bonnen, facturen) blijft bewaard. Het voertuig verdwijnt uit APK & Onderhoud, herinneringen en het klantportaal, en kan niet meer op nieuwe bonnen. Terugzetten kan altijd.')}
        </p>
        <label className="cs-section-title">{t('Reden')}</label>
        <select className="cs-input" value={reden} onChange={e => setReden(e.target.value)} data-testid="archiveer-auto-reden">
          <option value="">-- {t('Kies reden')} --</option>
          {ARCHIEF_REDENEN.map(r => <option key={r} value={r}>{t(r)}</option>)}
        </select>
        <label className="cs-section-title" style={{ marginTop: 10 }}>{t('Toelichting (optioneel)')}</label>
        <input className="cs-input" value={toelichting} onChange={e => setToelichting(e.target.value)} maxLength={300} placeholder={t('Bv. verkocht aan particulier')} data-testid="archiveer-auto-toelichting" />
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 14 }}>
          <button className="cs-btn" onClick={onClose}>{t('Annuleren')}</button>
          <button className="cs-btn primary" onClick={save} disabled={busy || !reden} data-testid="archiveer-auto-bevestig"><Archive size={14} /> {t('Archiveren')}</button>
        </div>
      </div>
    </div>
  );
}
